@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.flex-input-container {
  border-radius: 4px;
  position: relative;
  height: 32px;
  padding: 0;
  margin: 5px;
  line-height: 28px;
  transition: all 300ms ease;
  background: @input-v1-DEPRECATED--background-color;
  display: flex;
  font-size: 14px;

  &.without-label {
    margin: 0;
  }

  &.error {
    .flex-input {
      border: solid 1px @input-v1-DEPRECATED--error--border-color;
    }

    .flex-label {
      color: @input-v1-DEPRECATED--error--text-color;
    }
  }

  &:not(.disabled) {
    > input:hover {
      border: solid 1px @input-v1-DEPRECATED--hover--border-color;
    }
  }

  &.disabled {
    opacity: 0.5;
  }

  .flex-label {
    padding-right: 15px;
    white-space: nowrap;
    flex: 1;
    text-align: right;
  }

  .flex-input-wrapper {
    display: flex;
    flex: 3;
  }

  .flex-input {
    position: relative;
    z-index: 1;
    width: 100%;
    padding: 12px 10px;
    height: 100%;
    background: transparent;
    transition: all 300ms ease;
    display: block;
  }
}

.required-label {
  color: @input-v1-DEPRECATED--error--text-color;
  position: absolute;
  top: -5px;
  padding-left: 2px;
  font-size: 10px;
}
